// TODO
// Refacto d"une vraie popup custom...
// les notifications doivent être des interfaces !
export class NotificationModelBase {
    constructor() {
        this.closeOnBackdropClick = true;
        this.onClose = () => { };
    }
}
export class NotificationModel extends NotificationModelBase {
}
export class NotificationCustomModel extends NotificationModelBase {
    constructor() {
        super(...arguments);
        this.popupSlot = 'A';
    }
}
export class NotificationConfirmModel extends NotificationModelBase {
    constructor(showOk = true, showCancel = true, OkButtonText = 'OK', CancelButtonText = 'Annuler') {
        super();
        this.showOk = showOk;
        this.showCancel = showCancel;
        this.OkButtonText = OkButtonText;
        this.CancelButtonText = CancelButtonText;
        this.onOk = () => { };
        this.onCancel = () => { };
    }
}
